var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popupWrap",
    class: {
      'active': _vm.openOrClose
    },
    on: {
      "click": _vm.dimmedClickHandler
    }
  }, [_c('div', {
    ref: "contentWrap",
    staticClass: "contentWrap"
  }, [_c('h2', [_vm._v(_vm._s(_vm.crntObj.publishType ? "공개하기" : "수정 버전 저장"))]), _vm.crntObj.publishType ? _c('dl', {
    staticClass: "info"
  }, [_vm._m(0), _c('dd', {
    class: _vm.cautionBlnPublic ? 'caution' : null
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publicActive,
      expression: "publicActive"
    }],
    attrs: {
      "type": "radio",
      "name": "publicActive",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.publicActive, "1")
    },
    on: {
      "change": function ($event) {
        _vm.publicActive = "1";
      }
    }
  }), _vm._v("일반회원 이상")]), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publicActive,
      expression: "publicActive"
    }],
    attrs: {
      "type": "radio",
      "name": "publicActive",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.publicActive, "2")
    },
    on: {
      "change": function ($event) {
        _vm.publicActive = "2";
      }
    }
  }), _vm._v("위원/간사")])])]) : _vm._e(), _vm.cautionBlnPublic ? _c('p', {
    staticClass: "caution"
  }, [_vm._v("공개 범위를 선택해주세요.")]) : _vm._e(), _c('dl', {
    staticClass: "desc"
  }, [_c('dd', {
    class: _vm.cautionBln ? 'caution' : null
  }, [_vm.str == '' ? _c('p', {
    staticClass: "placeholder"
  }, [_vm._v("문서 저장 시 필요한 정보를 입력하세요.")]) : _vm._e(), _c('p', {
    ref: "inputWrite",
    staticClass: "write",
    attrs: {
      "contenteditable": ""
    },
    on: {
      "input": _vm.typeHandler
    }
  })])]), _vm.cautionBln ? _c('p', {
    staticClass: "caution"
  }, [_vm._v("필수 입력값입니다.")]) : _vm._e(), _c('p', {
    staticClass: "explain"
  }, [_vm._v(" " + _vm._s(_vm.crntObj.publishType ? "선택한 공개 범위로 공개하시겠습니까?" : "해당 문서 수정 버전을 저장 관리합니다.") + " ")]), _c('button', {
    staticClass: "btnConfirm",
    on: {
      "click": function ($event) {
        return _vm.confirmHandler($event);
      }
    }
  }, [_vm._v("완료")]), _c('close-btn', {
    attrs: {
      "closeHandler": _vm.clickCloseHandler
    }
  })], 1), _c('div', {
    ref: "publishCanvas",
    staticClass: "canvas"
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dt', [_c('span', [_vm._v("범위")])]);

}]

export { render, staticRenderFns }